import {
  useField,
} from 'formik';
import PropTypes from 'prop-types';
import { DateField } from '../../InputFields';

export const FormikDateField = ({
  name,
  label,
  minDate,
  maxDate,
}) => {
  const [field, meta] = useField(name);

  return (
    <DateField
      id={field.name}
      name={field.name}
      onChange={(value) => field.onChange({
        target: {
          name: field.name,
          value,
        },
      })}
      value={field.value}
      onBlur={field.onBlur}
      label={label}
      helperText={meta.error}
      maxDate={maxDate}
      minDate={minDate}
    />
  );
};

FormikDateField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
};
